// Client mirror of the u.center engine spec.

export const PACKAGES = [
  { id: "bronze",   name: "Bronze",   price: 100,  packageRankIdx: 0,  points: 77,      color: "#B45309" },
  { id: "silver",   name: "Silver",   price: 250,  packageRankIdx: 1,  points: 202.13,  color: "#CBD5E1" },
  { id: "gold",     name: "Gold",     price: 500,  packageRankIdx: 2,  points: 415.80,  color: "#F59E0B" },
  { id: "platinum", name: "Platinum", price: 1000, packageRankIdx: 3,  points: 870.10,  color: "#A855F7" },
  { id: "diamond",  name: "Diamond",  price: 2500, packageRankIdx: 4,  points: 2213.75, color: "#EC4899" },
];

// Official U.CENTER rank thresholds (from docs 5.2). R1 starts at $0 QV;
// each subsequent rank roughly doubles until R11, then a distinct schedule
// for the Deep Ripple leadership groups R12-R20.
const RANK_QV = [
  0,          // R1
  1_000,      // R2
  2_000,      // R3
  4_000,      // R4
  8_000,      // R5
  16_000,     // R6
  32_000,     // R7
  64_000,     // R8
  128_000,    // R9
  256_000,    // R10
  512_000,    // R11
  1_000_000,  // R12
  2_000_000,  // R13
  4_000_000,  // R14
  8_000_000,  // R15
  16_000_000, // R16
  32_000_000, // R17
  64_000_000, // R18
  128_000_000,// R19
  256_000_000,// R20
];

const buildUnlock = (n) => {
  if (n <= 5) return `Initial Ripple tier ${n}`;
  if (n <= 11) {
    const tiers = n - 5;
    return `Ripple Wave · ${tiers}× 1% per downline order`;
  }
  const posInGroup = ((n - 12) % 3) + 1;
  const groupIdx = Math.floor((n - 12) / 3);
  const group = ["G1", "G2", "G3"][groupIdx];
  const pct = [0.3, 0.6, 0.9][posInGroup - 1];
  return `Deep Ripple ${group} · ${pct}%/order`;
};

export const RANKS = RANK_QV.map((qv, i) => ({
  rank: `R${i + 1}`,
  qv,
  benchmark: i === 0 ? 0 : RANK_QV[i] - RANK_QV[i - 1],
  unlock: buildUnlock(i + 1),
}));

export const INITIAL_RIPPLE = [0.10, 0.05, 0.025, 0.0125, 0.00625];
export const RIPPLE_WAVE_RATE = 0.01;
export const RIPPLE_WAVE_TIERS = 6;
export const DROP_MATCH = [0.01, 0.03, 0.06];
export const CAP_PAYMENTS_PER_ORDER = 3;

export const DEFAULT_ADVANCED = {
  duplicationMultiplier: 1.0,
  branchingFactor: 2.5,
  retentionRate: 1.0,
};

export const packageById = (id) => PACKAGES.find((p) => p.id === id) || PACKAGES[0];

export const volumeRankIndex = (v) => {
  let r = -1;
  for (let i = 0; i < RANKS.length; i++) {
    if (v >= RANKS[i].qv) r = i; else break;
  }
  return r;
};

export const rankByIndex = (idx) => idx < 0
  ? { rank: "R0", qv: 0, benchmark: 0, unlock: "None (below R1)" }
  : RANKS[Math.min(idx, RANKS.length - 1)];
